module.exports = __webpack_public_path__ + "img/reg.55f326b5.png";